import StatusKaryawan from './StatusKaryawan'

export default StatusKaryawan